<template>
  <div class="container-fluid">
    <vue-title
      :title="'Tospaa Code Challenge - Multiplayer Coding Game'"
    ></vue-title>
    <div v-if="showTutorial">
      <transition name="modal">
        <div class="modal-mask" data-backdrop="false" data-keyboard="true">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-xl" role="dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" v-on:click="closeTutorialModal"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body">
                  <vue-plyr :options="options">
                    <video>
                      <source
                        src="@/assets/videos/tutorial1.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </vue-plyr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div
      style="
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: hidden;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
      "
    >
      <div
        style="
          position: absolute;
          bottom: 50%;
          z-index: 0;
          left: 50%;
          animation: mymove 50s infinite linear;
        "
      >
        <img src="@/assets/images/cloud-01.png" />
      </div>
      <div
        style="
          position: absolute;
          bottom: 40%;
          z-index: 0;
          animation: mymove 80s infinite linear;
          animation-delay: -40s;
        "
      >
        <img src="@/assets/images/cloud-02.png" />
      </div>
      <div
        style="
          position: absolute;
          bottom: 45%;
          z-index: 0;
          left: 50%;
          animation: mymove 60s infinite linear;
          animation-delay: -40s;
        "
      >
        <img src="@/assets/images/cloud-01.png" />
      </div>
      <div
        style="
          position: absolute;
          bottom: 0;
          z-index: 1;
          left: 5%;
          width: 90%;
          z-index: -1;
        "
      >
        <img src="@/assets/images/bg-grass.png" class="img-fluid" />
      </div>

      <div
        style="
          width: 60%;
          height: 150px;
          border-radius: 100%;
          background-color: #d3a159;
          position: absolute;
          bottom: -100px;
          left: 20%;
        "
      ></div>

      <div
        style="
          position: absolute;
          width: 200px;
          height: 170px;
          bottom: 0;
          left: 50%;
          margin-left: -100px;
        "
        id="tospaaChar"
      >
        <div style="position: absolute; bottom: 0; z-index: 1; left: 0%">
          <img src="@/assets/images/tospaa-p01.png" />
        </div>
        <div
          style="position: absolute; bottom: 50px; z-index: 0; left: 120px"
          id="tospaaP02"
        >
          <img src="@/assets/images/tospaa-p02.png" />
        </div>
        <div
          style="position: absolute; bottom: 110px; z-index: 0; left: 130px"
          id="tospaaP03"
        >
          <img src="@/assets/images/tospaa-p03.png" />
        </div>
        <div
          style="position: absolute; bottom: 118px; z-index: 0; left: 137px"
          id="tospaaP04"
        >
          <img src="@/assets/images/tospaa-p04.png" />
        </div>
      </div>
    </div>

    <div id="header" class="row justify-content-center">
      <div
        class="col-12 d-flex justify-content-center"
        style="position: relative"
      >
        <img id="header-challenge-logo" src="@/assets/images/game_logo.png" />
      </div>
      <div class="col-12 p-3 justify-content-center" style="text-align: center">
        <p style="font-size: 24px; font-weight: bold">Hello, I'm tospaa.</p>
        Would you like to go on a coding journey with me?<br />
        Come on then!
      </div>

      <!--<div class="col-1 d-flex justify-content-center align-items-end">
        <img id="settings-icon" class="img-fluid mx-auto" src="@/assets/images/settings_icon.svg"/>
      </div>
      <div class="col-1 d-flex justify-content-center align-items-end">
        <img id="chart-icon" class="img-fluid mx-auto" src="@/assets/images/chart_icon.svg"/>
      </div>-->
    </div>

    <div class="row p-4 justify-content-center">
      <div class="col col-auto my-auto">
        <div id="login" class="row">
          <div class="d-flex flex-column bd-highlight">
            <div class="bd-highlight p-1 input-group">
              <input
                v-model.trim="userName"
                class="form-control"
                required
                type="text"
                placeholder="Kullanıcı adı"
              />
              <!--
              <span
                  class="badge badge-info my-auto badge-pill mx-1"
                  data-toggle="tooltip"
                  title="Kullanıcı adı en fazla 30 karakter olabilir. Sadece harf sayı, boşluk ve _ içerebilir."
              >?</span>
              -->
            </div>
            <div class="text-center">
              <span v-if="err" class="text-danger">{{ err }}</span>
            </div>
            <div class="bd-highlight p-1">
              <button
                style="width: 70%"
                v-if="!err"
                class="btn btn-info tospaaBlue m-1"
                v-on:click="login"
              >
                login
              </button>

              <button
                style="width: 20%"
                v-if="!err"
                class="btn btn-info tospaaBlue m-1"
                v-on:click="openTutorialModal"
                data-toggle="tooltip"
                data-placement="bottom"
                title="How to play?"
              >
                ?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie } from "tiny-cookie";

export default {
  data() {
    return {
      userName: "tospaa",
      err: "",
      userCountry: "",
      showTutorial: false,
    };
  },

  created() {
    this.$options.sockets.onmessage = (data) => this.messageReceived(data);
    this.userName = getCookie("userName");
    if (this.userName == "") {
      this.userName = "tospaa" + Math.floor(Math.random() * 100);
    }

    //TODO uncooment this before upload

    fetch("https://ipinfo.io/json?token=49dc4ab66c21e6")
      .then((response) => response.json())
      .then((jsonResponse) => (this.userCountry = jsonResponse.country));
  },

  computed: {
    isConnected() {
      return this.$store.state.socket.isConnected;
    },
  },

  watch: {
    isConnected() {},

    userName(value) {
      this.userName = value;
      this.validateUserName(this.userName);
    },
  },

  methods: {
    validateUserName(value) {
      if(!value){
        this.err = "Username is empty!";
        return false;
      }
      else if (value.length < 2) {
        this.err = "Username is too short!";
        return false;
      } else if (/^[a-zA-Z0-9ğüşöçİĞÜŞÖÇ _]{1,30}$/.test(value)) {
        this.err = "";
        return true;
      } else if (value.length > 30) {
        this.err = "Username is too long!";
        return false;
      } else {
        this.err = "Invalid chars in username!";
        return false;
      }
    },

    login: function () {
      if (!this.isConnected) {
        this.$swal.fire(
          "Try again!",
          "Login failed! Connection error!",
          "error"
        );
      } else if (this.validateUserName(this.userName)) {
        let obj = {};
        obj.event = "login";
        obj.userName = this.userName;
        obj.userConuntry = this.userCountry;
        this.$socket.sendObj(obj);
        setCookie("userName", this.userName, { expires: "2Y" });
      }
    },
    closeTutorialModal: function () {
      this.showTutorial = false;
    },

    openTutorialModal: function () {
      this.showTutorial = true;
    },

    messageReceived: function (raw_message) {
      let receivedData = JSON.parse(raw_message["data"]);
      if (!Object.prototype.hasOwnProperty.call(receivedData, "event")) {
        console.error("event not found");
        return;
      }
      let event = receivedData["event"];
      if (event === "login") {
        if (receivedData["status"] === "pass") {
          this.$router.push({
            name: "lounge",
            params: {
              userName: this.userName,
            },
          });
        } else {
          console.error("Login failed");
          this.userName = "";
          this.$swal.fire("Try again!", "Login failed! Entry denied.", "error");
        }
      }
    },
  },
};
</script>
